export const Packages_Action_Types = {
    FETCH_PACKAGES_START: "packages/FETCH_PACKAGES_START",
    FETCH_PACKAGES_SUCCESS: "packages/FETCH_PACKAGES_SUCCESS",
    FETCH_PACKAGES_LIST_BY_TYPE: "packages/FETCH_PACKAGES_LIST_BY_TYPE",
    FETCH_PACKAGES_FAILED: "packages/FETCH_PACKAGES_FAILED",
    SET_PAGE_SIZE: "packages/SET_PAGE_SIZE",
    SET_IS_UPDATED: "packages/SET_IS_UPDATED",
    SET_PAGE_NUMBER: "packages/SET_PAGE_NUMBER",
    SET_FILTER_SEARCH_STRING: "packages/SET_FILTER_SEARCH_STRING",
    }